module.exports = "/assets/data/1915b74ffffb9a577cd40a510f0e60b1-IP3.data.json";